// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import YahooFilledSvg from "@ant-design/icons-svg/es/asn/YahooFilled";
import AntdIcon from '../components/AntdIcon';

var YahooFilled = function YahooFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: YahooFilledSvg
  }));
};

YahooFilled.displayName = 'YahooFilled';
export default React.forwardRef(YahooFilled);